import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateDiscordMessageMutationVariables = Types.Exact<{
  input: Types.CreateDiscordMessageInput;
}>;

export type CreateDiscordMessageMutation = {
  __typename?: 'Mutation';
  createDiscordMessage: {
    __typename?: 'DiscordMessage';
    id: any;
    content: string;
    embeds?: any | null;
    username?: string | null;
    avatarUrl?: string | null;
    tts: boolean;
    createdAt: any;
    updatedAt: any;
  };
};

export const CreateDiscordMessageDocument = gql`
  mutation CreateDiscordMessage($input: CreateDiscordMessageInput!) {
    createDiscordMessage(input: $input) {
      id
      content
      embeds
      username
      avatarUrl
      tts
      createdAt
      updatedAt
    }
  }
`;
export type CreateDiscordMessageMutationFn = Apollo.MutationFunction<
  CreateDiscordMessageMutation,
  CreateDiscordMessageMutationVariables
>;

/**
 * __useCreateDiscordMessageMutation__
 *
 * To run a mutation, you first call `useCreateDiscordMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscordMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscordMessageMutation, { data, loading, error }] = useCreateDiscordMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDiscordMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDiscordMessageMutation,
    CreateDiscordMessageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDiscordMessageMutation,
    CreateDiscordMessageMutationVariables
  >(CreateDiscordMessageDocument, options);
}
export type CreateDiscordMessageMutationHookResult = ReturnType<
  typeof useCreateDiscordMessageMutation
>;
export type CreateDiscordMessageMutationResult =
  Apollo.MutationResult<CreateDiscordMessageMutation>;
export type CreateDiscordMessageMutationOptions = Apollo.BaseMutationOptions<
  CreateDiscordMessageMutation,
  CreateDiscordMessageMutationVariables
>;
